import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useHoteleria} from '../../../../hooks/useHoteleria'
import {getSnackBarToast} from '../../../../util/snackBar'
import ContainerWrapper from '../../../central/pages/componentes/Container'
import {renderPanelContent} from '../../components/components'
import {bookingFaceToFaceSchema} from '../../schemas/booking.schema'
import {
  createReserveCheckInService,
  downloadPDFCheckInOutService,
  getHuespedEsRelevoService,
} from '../../services/booking.service'
import {createRelevoWithLists, updateRelevoWithLists} from '../../services/relevo.service'
import ActionsContent from '../components/Actions'

const BookingFaceToFacePageWrapper: FC = () => {
  const {currentTabItem} = useHoteleria()
  const [loading, setLoading] = useState(false)

  const methods = useForm({
    resolver: yupResolver(bookingFaceToFaceSchema),
    defaultValues: {
      CampamentoId: '',
      FechaInicio: moment().format('YYYY-MM-DD'),
      FechaFin: moment().format('YYYY-MM-DD'),
      NumeroDocumento: '',
      StatusId: '',
      ModuloId: '',
      HabitacionId: '',
      CamaId: '',
      CamaIdFake: '',
      EmpresaContratista: '',
      CheckOutRelevo: false,
      OtrasHabitacionesDisponibles: false,
      ReservaYCheckin: true,
      Impresion: true,
      HuespedId: '',
      NombresCompletos: '',
      HuespedRelevoId: '',
      HuespedRelevoNombre: '',
      VolverRelevo: false,
      HuespedRelevoTieneRelevo: false,
      HabilitarHuespedRelevo: false,
      // Campos para guardar la respuesta de getHuespedEsRelevoService
      RelevoDataResponse: null,
      //Estados checkout
      checkout: false,
      checkout_reservaId: null,
      checkout_camaId: null,
      checkout_huespedId: null,
      checkout_estadocama: null,
      checkout_reservacamaId: null,
      //variables de apoyo
      bedStatus: '',
      nameGuest: '',
      isRelevo: false,
      relevoId: null,
      hasRelevoCompleteData: false,
      HuespedNombreOcupada: '',
      tipoBusqueda: '',
      loadingVolverRelevo: true,
      camaConfigurada: false,
      dias: 0,
      CamaCalienteId: '',
    },
  })

  const campamentoId = methods.watch('CampamentoId')

  const printPdf = (pdfUrl: any) => {
    const printWindow = window.open(pdfUrl, '_blank')
    if (printWindow) {
      printWindow.addEventListener('load', () => {
        printWindow.focus()
        printWindow.print()
      })
    }
  }

  const handleRestText = () => {
    methods.reset({
      CampamentoId: campamentoId || '',
      FechaInicio: moment().format('YYYY-MM-DD'),
      FechaFin: moment().format('YYYY-MM-DD'),
      NumeroDocumento: '',
      StatusId: '',
      ModuloId: '',
      HabitacionId: '',
      CamaId: '',
      CamaIdFake: '',
      EmpresaContratista: '',
      CheckOutRelevo: false,
      OtrasHabitacionesDisponibles: false,
      ReservaYCheckin: true,
      Impresion: true,
      HuespedId: '',
      NombresCompletos: '',
      HuespedRelevoId: '',
      HuespedRelevoNombre: '',
      VolverRelevo: false,
      HabilitarHuespedRelevo: false,
      // Campos para guardar la respuesta de getHuespedEsRelevoService
      RelevoDataResponse: null,
      checkout: false,
      checkout_reservaId: null,
      checkout_camaId: null,
      checkout_huespedId: null,
      checkout_estadocama: null,
      checkout_reservacamaId: null,
      //variables de apoyo
      bedStatus: '',
      nameGuest: '',
      isRelevo: false,
      relevoId: null,
      hasRelevoCompleteData: false,
      HuespedNombreOcupada: '',
      tipoBusqueda: '',
      HuespedRelevoTieneRelevo: false,
      loadingVolverRelevo: true,
      camaConfigurada: false,
      dias: 0,
      CamaCalienteId: '',
    })
  }

  const onSubmit = async (data: any) => {
    // console.log(data)
    try {
      // if (data.HuespedRelevoTieneRelevo) {
      //   getSnackBarToast('No se puede guardar: El huésped relevo tiene un relevo activo', 'error')
      //   return
      // }

      setLoading(true)

      let relevoId = methods.getValues('relevoId') || data.RelevoId || data.relevoId || ''
      let estadoCamaData: any = null // Guardar toda la información del estado de la cama

      let relevoDataResponse: any = data.RelevoDataResponse || null

      if (!relevoDataResponse && data.HuespedId) {
        try {
          const relevoCheckRequest = {
            huespedId: data.HuespedId,
            fechaini: data.FechaInicio
              ? new Date(data.FechaInicio).toISOString().split('T')[0]
              : null,
            fechafin: data.FechaFin ? new Date(data.FechaFin).toISOString().split('T')[0] : null,
          }
          const relevoCheckResponse = await getHuespedEsRelevoService(relevoCheckRequest)
          if (relevoCheckResponse.data.data) {
            relevoDataResponse = relevoCheckResponse.data.data
          }
        } catch (error) {
          console.error('Error verificando si es relevo:', error)
        }
      }

      if (relevoDataResponse) {
        const relevoIdValue =
          relevoDataResponse.relevoId || relevoDataResponse.RelevoId || data.RelevoId
        if (relevoIdValue) {
          relevoId = String(relevoIdValue)
        }
      } else if (data.RelevoId) {
        relevoId = data.RelevoId
      }

      if (data.VolverRelevo) {
        if (!data.isRelevo) {
          try {
            const usuarios: {UsuarioId: string}[] = []
            if (data.UsuarioIdRelevo) {
              usuarios.push({UsuarioId: data.UsuarioIdRelevo})
            }
            if (data.UsuarioId) {
              usuarios.push({UsuarioId: data.UsuarioId})
            }

            const habitaciones: {ModuloId: string; HabitacionId: string}[] = []
            if (data.ModuloId && data.HabitacionId) {
              habitaciones.push({
                ModuloId: data.ModuloId,
                HabitacionId: data.HabitacionId,
              })
            }

            const createRelevoData = {
              CampamentoId: data.CampamentoId || '',
              Usuarios: usuarios,
              Habitaciones: habitaciones,
            }
            const createResponse = await createRelevoWithLists(createRelevoData)
          } catch (error) {
            console.error('Error creando/actualizando relevo con lists:', error)
          }
        } else {
          try {
            const usuarios: {UsuarioId: string}[] = []
            if (data.UsuarioId) {
              usuarios.push({UsuarioId: data.UsuarioIdRelevo})
            }
            const updateRelevoData = {
              CampamentoId: data.CampamentoId || '',
              Id: relevoId,
              Usuarios: usuarios,
            }
            await updateRelevoWithLists(updateRelevoData)
          } catch (error) {
            console.error('Error creando/actualizando relevo con lists:', error)
          }
        }
      }

      const requestData = {
        camaId: data.CamaId || '',
        huespedId: data.HuespedId || '',
        companiaId: data.CompaniaId || '',
        clienteId: data.ClienteId || '',
        siteId: data.SiteId || '',
        campamentoId: data.CampamentoId || '',
        fechaIni: data.FechaInicio ? new Date(data.FechaInicio).toISOString() : '',
        fechaFin: data.FechaFin ? new Date(data.FechaFin).toISOString() : '',
        checkout: data.checkout,
        checkout_reservaId: data.checkout_reservaId,
        checkout_camaId: data.checkout_camaId,
        checkout_huespedId: data.checkout_huespedId,
        checkout_estadocama: data.checkout_estadocama,
        checkout_reservacamaId: data.checkout_reservacamaId,
        camaCalienteId: data.CamaCalienteId,
      }

      const response = await createReserveCheckInService(requestData)

      if (!response.data.error) {
        console.log('response', response.data.data)
        const reservaCamaId =
          response.data?.data?.reservaCamaId || response.data?.data?.reservacamaid
        let pdfUrl: string | null = null

        if (data.VolverRelevo && relevoId) {
          try {
            console.log('Volver Relevo - Servicio pendiente de implementar', {
              relevoId,
              reservaCamaId,
              huespedRelevoId: data.HuespedRelevoId,
            })
          } catch (error) {
            console.error('Error en Volver Relevo:', error)
          }
        }

        if (reservaCamaId && methods.watch('Impresion')) {
          try {
            const pdfDto = {
              reservaCamaId: reservaCamaId,
              tipo: 'IN',
              MotivoReimpresionId: '',
              Otros: '',
            }
            const pdfResponse = await downloadPDFCheckInOutService(pdfDto)
            const blob = new Blob([pdfResponse.data], {type: 'application/pdf'})
            pdfUrl = window.URL.createObjectURL(blob)
            setTimeout(() => {
              printPdf(pdfUrl!)
            }, 1000)
          } catch (pdfError) {
            console.error('Error descargando PDF:', pdfError)
          }

          if (pdfUrl) {
            const printButton = document.getElementById('printButton') as HTMLElement
            if (printButton) {
              printButton.addEventListener('click', () => {
                printPdf(pdfUrl!)
              })
            }
          }
        }
        setLoading(false)
        getSnackBarToast('Se creó con éxito', 'success')
        setLoading(false)
        handleRestText()
      } else {
        getSnackBarToast(response.data.message, 'error')
        setLoading(false)
      }
      setLoading(false)
    } catch (error) {
      console.error('Error en onSubmit:', error)
      getSnackBarToast('Hubo un error interno', 'error')
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          loading={loading}
          textComponentGo='form-booking-face-to-face'
          showBackButton={false}
          resetFilter
          resetFilterFunction={handleRestText}
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-hoteleria-relevos-${currentTabItem.id}`}
              id={`panel-hoteleria-relevos-${currentTabItem.id}`}
              className={'panel__box'}
              defaultSize={100}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export {BookingFaceToFacePageWrapper}
